import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/privacy-policy")({
  head: () => pageHead("privacy", "en"),
  component: PrivacyPolicy,
});
